<template>
  <div class="fts-variable-assignment-display">
    <template v-if="action && action.valueExpand">
      <div
        class="variable-assignment variable-assignment--inline"
        v-for="field in fields"
        :key="field.id"
      >
        <fts-automation-label
          :label-name="field.displayName"
          :label-type="field.icon"
          :label-module-id="field.moduleId"
          tooltip
        />

        <fts-formula-display 
          :formula="field.value" 
          :variables="variables" 
          tooltip 
          no-wrap 
          class="variable-assignment__value" 
        />
      </div>

      <div class="variable-assignment-more" v-if="action.fields.length > 2">
        show more
      </div>
    </template>
    
    <div class="variable-assignment" v-else-if="action && action.value">
      <fts-formula-display 
        :formula="action.value" 
        :variables="variables" 
        tooltip 
        no-wrap 
        class="variable-assignment__value"
      />
    </div>
  </div>
</template>

<script>
import FTSFormulaDisplay from "../FTSFormulaDisplay.vue";
import FTSAutomationLabel from "./FTSAutomationLabel.vue";

export default {
  props: {
    moduleId: String,
    action: Object,
    variables: Array,
  },
  data: () => ({
    module: null,
  }),
  components: {
    "fts-automation-label": FTSAutomationLabel,
    "fts-formula-display": FTSFormulaDisplay,
  },
  computed: {
    fields() {
      if (
        this.action && Array.isArray(this.action.fields) &&
        this.module && Array.isArray(this.module.information)
      ) {
        let assignFields = _.cloneDeep(this.action.fields)
          .slice(0, 2)
          .map((x) => {
            let information = this.module.information.find(
              (y) => y.fieldName == x.key
            );

            if (!information) {
              if (this.action.informationId) {
                let table = this.module.information.find(
                  (y) => y.id == this.action.informationId
                );
                information = table.fields.find((y) => y.fieldName == x.key);
              }
            }

            return {
              ...x,
              displayName: information.displayName, // set display name
              icon: information.type, // set icon type
              moduleId: information.moduleId // module ref -> user-defined emoji
            };
          });

        return assignFields;
      }
    }
  },
  async mounted() {
    let vm = this;
    if (vm.moduleId) {
      let data = await this.$store.dispatch("findVariable", {
        moduleId: vm.moduleId,
      });

      vm.module = data;
    }
  },
};
</script>

<style lang="scss" scoped>
.fts-variable-assignment-display {
  .variable-assignment {
    .variable-assignment__value {
      max-width: 100%;
      display: inline-block;
    }
    &:not(:last-child) {
      margin-bottom: 0.25rem;
    }
    &.variable-assignment--inline {
      display: flex;
      justify-content: space-between;
      .fts-automation-label {
        flex: 2 1 60%;
      }

      .variable-assignment__value {
        flex: 1;
        max-width: 50%;
        margin-left: 0.75rem;
        text-align: right;
      }
    }
  }
  .variable-assignment-more {
    color: var(--fts-default);
  }
}
</style>